
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.97 1h-2.94C16.76 1 16 1.76 16 3.03v2.94C16 7.24 16.76 8 18.03 8h2.94C22.24 8 23 7.24 23 5.97V3.03C23 1.76 22.24 1 20.97 1zm.5 4.56c.25.25.25.66 0 .91a.667.667 0 01-.91 0L19.5 5.41l-1.05 1.06a.667.667 0 01-.91 0 .646.646 0 010-.91L18.6 4.5l-1.06-1.05a.646.646 0 010-.91c.25-.25.66-.25.91 0L19.5 3.6l1.06-1.06c.25-.25.66-.25.91 0s.25.66 0 .91L20.41 4.5l1.06 1.06zM9 10.38a2.38 2.38 0 100-4.76 2.38 2.38 0 000 4.76z","fill":"#292D32"}}),_c('path',{attrs:{"d":"M20.97 8h-.47v4.61l-.13-.11c-.78-.67-2.04-.67-2.82 0l-4.16 3.57c-.78.67-2.04.67-2.82 0l-.34-.28c-.71-.62-1.84-.68-2.64-.14l-3.74 2.51c-.22-.56-.35-1.21-.35-1.97V7.81c0-2.82 1.49-4.31 4.31-4.31H16v-.47c0-.4.07-.74.23-1.03H7.81C4.17 2 2 4.17 2 7.81v8.38c0 1.09.19 2.04.56 2.84.86 1.9 2.7 2.97 5.25 2.97h8.38c3.64 0 5.81-2.17 5.81-5.81V7.77c-.29.16-.63.23-1.03.23z","fill":"#292D32"}})])
          )
        }
      }
    